/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageLink, PageTitle, useLayout } from '../../../_metronic/layout/core'
import { CardsWidget20, ListsWidgetHighlight } from '../../../_metronic/partials/widgets'
import { ChartsWidgetSMSStats } from '../../../_metronic/partials/widgets/_new/charts/ChartsWidgetSMSStats'
import { axiosClientAuth } from '../../utils'
import { useQuery } from 'react-query'
import dayjs from 'dayjs'

const SMSReport: FC = () => {
  const intl = useIntl()
  const { peIdSmsReport, dateFilterSmsReport, setDateFilterSmsReport } = useLayout()

  useEffect(() => {
    setDateFilterSmsReport([
      dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
      dayjs().format('YYYY-MM-DD'),
    ])
  }, [])

  const fromDate = dateFilterSmsReport?.[0] || dayjs().subtract(6, 'day').format('YYYY-MM-DD')
  const toDate = dateFilterSmsReport?.[1] || dayjs().format('YYYY-MM-DD')

  const { data: statsData } = useQuery(
    ['sms-operator-stats', { fromDate, toDate, ownerId: peIdSmsReport }],
    () =>
      axiosClientAuth
        .get('/analytics/operator-stats/', {
          params: {
            from_date: fromDate,
            to_date: toDate,
            ...(peIdSmsReport ? { owner_id: peIdSmsReport } : {}),
          },
        })
        .then((res) => res.data.data)
  )

  const rawResults: any[] = statsData?.results ?? []

  const chartResults =
    rawResults.length === 1
      ? [
          {
            date: dayjs(rawResults[0].date).subtract(1, 'day').format('YYYY-MM-DD'),
            success_billable: 0,
            failed_billable: 0,
          },
          ...rawResults,
        ]
      : rawResults

  const smsStats = {
    total: rawResults.reduce((a: number, r: any) => a + (r.total_billable ?? 0), 0),
    successful: rawResults.reduce((a: number, r: any) => a + (r.success_billable ?? 0), 0),
    unsuccessful: rawResults.reduce((a: number, r: any) => a + (r.failed_billable ?? 0), 0),
    chart: {
      month: chartResults.map((r: any) => r.date),
      values_success: chartResults.map((r: any) => r.success_billable ?? 0),
      values_unsuccess: chartResults.map((r: any) => r.failed_billable ?? 0),
    },
  }

  return (
    <>
      <div className='row'>
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          <CardsWidget20
            className='h-md-50 mb-5 mb-xl-10'
            description={intl.formatMessage({ id: 'SMS.SUBMITTED', defaultMessage: 'Number of SMS Submitted' })}
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
            total={smsStats?.total}
            failed={smsStats?.unsuccessful}
          />
          <ListsWidgetHighlight
            className='h-lg-50'
            successful={smsStats?.successful}
            unsuccessful={smsStats?.unsuccessful}
          />
        </div>
        <div className='col-xxl-9'>
          <ChartsWidgetSMSStats
            className='h-100 mb-xl-8'
            chartData={smsStats?.chart}
            total={smsStats?.total}
          />
        </div>
      </div>
    </>
  )
}

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const SMSReportWrapper: FC = () => {
  const { setRightTolbar } = useLayout()
  const intlSms = useIntl()

  useEffect(() => {
    setRightTolbar('smsreport')
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={myBreadCrumbs}>{intlSms.formatMessage({ id: 'PAGE.SMS_REPORT', defaultMessage: 'SMS Report' })}</PageTitle>
      <SMSReport />
    </>
  )
}

export { SMSReportWrapper }
